import { useNavigate } from "react-router-dom";

const AccountStatusModals = ({
  accountDeletedPopup,
  setAccountDeletedPopup,
  accountDisabledPopup,
  setAccountDisabledPopup,
  isEnabling,
  handleReactivateAccount,
  deletedAccount,
  isDeletedBusy,
  handleReactivateDeleted,
  handleHardDeleteAndSignup,
}) => {
  const navigate = useNavigate();

  return (
    <>
      {accountDeletedPopup && (
        <div className="modal-overlay">
          <div className="confirm-modal">
            <h2>Account Deleted</h2>
            {deletedAccount ? (
              <>
                <p>
                  An account that was deleted exists with this phone number. You
                  can reactivate it, or permanently delete it and sign up as a
                  new user.
                </p>
                <div className="modal-actions">
                  <button
                    className="confirm-btn"
                    onClick={handleReactivateDeleted}
                    disabled={isDeletedBusy}
                  >
                    Reactivate
                  </button>
                  <button
                    className="cancel-btn"
                    onClick={handleHardDeleteAndSignup}
                    disabled={isDeletedBusy}
                  >
                    Delete &amp; sign up new
                  </button>
                </div>
              </>
            ) : (
              <p>Your account has been permanently deleted. Please contact support if you believe this is a mistake.</p>
            )}
            <div className="modal-actions">
              <button
                className="confirm-btn"
                onClick={() => { setAccountDeletedPopup(false); navigate("/home"); }}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {accountDisabledPopup && (
        <div className="modal-overlay">
          <div className="confirm-modal">
            <h2>Account Disabled</h2>
            <p>Your account is currently disabled. Would you like to reactivate your account?</p>
            <div className="modal-actions">
              <button
                className="confirm-btn"
                onClick={handleReactivateAccount}
                disabled={isEnabling}
                style={{ opacity: isEnabling ? 0.7 : 1, cursor: isEnabling ? "not-allowed" : "pointer" }}
              >
                {isEnabling ? (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                    <span className="spinner"></span>Enabling...
                  </div>
                ) : "Enable Account"}
              </button>
              <button
                className="cancel-btn"
                onClick={() => { setAccountDisabledPopup(false); navigate("/home"); }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AccountStatusModals;